import api from '@/services/api/api';

export const useMagazines = (
  params = {
    page: 1,
  },
) => {
  const queryKey = computed(() => ['magazines', params.page]);

  const magazines = useInfiniteQuery(
    queryKey,
    async ({ pageParam = toValue(params.page) }) => {
      const { data } = await api.magazines.getMagazines({
        per_page: params.per_page,
        page: pageParam,
      });

      return data;
    },
    {
      staleTime: Infinity,
      select: ({ pages }) => ({
        meta: pages[pages.length - 1].meta,
        data: pages.flatMap((data) => data.data),
      }),
      getNextPageParam: (data) => {
        return data.meta.current_page < data.meta.last_page
          ? data.meta.current_page + 1
          : undefined;
      },
      refetchOnMount: true,
      keepPreviousData: true,
    },
  );

  onServerPrefetch(async () => {
    await magazines.suspense();
  });

  return {
    magazines,
  };
};
